import React, { ComponentProps } from 'react';

import cn from 'classnames';
import ReactPlayer from 'react-player';

import cls from './VideoPlayer.module.css';

type ReactPlayerProps = ComponentProps<typeof ReactPlayer>;

interface IVideoPlayerProps extends ReactPlayerProps {
    videoSrc?: string;
}
export const VideoPlayer = ({
    videoSrc = 'https://www.youtube.com/watch?v=LXb3EKWsInQ',
    className,
    width,
    height,
    ...rest
}: IVideoPlayerProps) => (
    <ReactPlayer
        className={cn(cls.VideoPlayerContainer, className)}
        src={videoSrc}
        width={width ?? '100%'}
        height={height ?? '100%'}
        {...rest}
    />
);
